var map = {
	"./banner-carousel.de-CH.json": 1091,
	"./banner-carousel.de-DE.json": 1092,
	"./banner-carousel.en-CA.json": 1093,
	"./banner-carousel.en-GB.json": 1094,
	"./banner-carousel.en-IN.json": 1095,
	"./banner-carousel.en-ME.json": 1096,
	"./banner-carousel.en-US.json": 1097,
	"./banner-carousel.es-EM.json": 1098,
	"./banner-carousel.es-ES.json": 1099,
	"./banner-carousel.fr-BE.json": 1100,
	"./banner-carousel.fr-CA.json": 1101,
	"./banner-carousel.fr-CH.json": 1102,
	"./banner-carousel.nl-BE.json": 1103,
	"./banner-carousel.nl-NL.json": 1104,
	"./banner-carousel.pl-PL.json": 1105,
	"./banner-carousel.pt-BR.json": 1106
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1090;